export const PersonOutlineIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.00008 2.40832C9.06341 2.40832 9.92508 3.26999 9.92508 4.33332C9.92508 5.39666 9.06341 6.25832 8.00008 6.25832C6.93675 6.25832 6.07508 5.39666 6.07508 4.33332C6.07508 3.26999 6.93675 2.40832 8.00008 2.40832ZM8.00008 10.6583C10.7226 10.6583 13.5917 11.9967 13.5917 12.5833V13.5917H2.40841V12.5833C2.40841 11.9967 5.27758 10.6583 8.00008 10.6583ZM8.00008 0.666656C5.97425 0.666656 4.33341 2.30749 4.33341 4.33332C4.33341 6.35916 5.97425 7.99999 8.00008 7.99999C10.0259 7.99999 11.6667 6.35916 11.6667 4.33332C11.6667 2.30749 10.0259 0.666656 8.00008 0.666656ZM8.00008 8.91666C5.55258 8.91666 0.666748 10.145 0.666748 12.5833V14.4167C0.666748 14.9208 1.07925 15.3333 1.58341 15.3333H14.4167C14.9209 15.3333 15.3334 14.9208 15.3334 14.4167V12.5833C15.3334 10.145 10.4476 8.91666 8.00008 8.91666Z"
        fill="currentColor"
      />
    </svg>
  );
};
